import type { PageTour } from '../types';

export const leaveTour: PageTour = {
  id: 'leave',
  label: 'Leave Management Tour',
  steps: [
    {
      target: '[data-tour="leave-header"]',
      title: 'Leave Management',
      content: 'Manage all your leave requests from this page. Apply for time off, check balances, and view your history.',
    },
    {
      target: '[data-tour="leave-apply"]',
      title: 'Apply for Leave',
      content: 'Click here to submit a new leave request. Choose the type, dates, and add any notes for your manager.',
    },
    {
      target: '[data-tour="leave-balances"]',
      title: 'Leave Balances',
      content: 'View your remaining leave balances at a glance — annual leave, sick leave, and other entitlements.',
    },
    {
      target: '[data-tour="leave-requests"]',
      title: 'Your Requests',
      content: 'See the status of all your leave requests. Track pending, approved, and declined applications.',
    },
  ],
};
